<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="选择渠道">
              <a-select
                show-search
                placeholder="请选择渠道"
                option-filter-prop="children"
                :filter-option="filterOption"
                v-model="queryParam.appid"
                @change="handleChange"
              >
                <a-select-option
                  v-for="(item, index) in wechatApp"
                  :key="'info2-' + index"
                  :value="item.appId"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button type="primary" icon="plus" @click="handleRouter"
            >新建</a-button
          >
          <a-button style="float: right" @click="getMenu">菜单同步</a-button>
          <a-button style="float: right" @click="handleRouter">预览</a-button>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="key"
        :columns="columns"
        :dataSource="menuList"
        class="j-table-force-nowrap"
        :pagination="false"
        :loading="loading"
      >
      </a-table>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
// import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { getAction } from '@/api/manage';

export default {
  name: 'WechatAppList',
  // mixins: [mixinDevice],
  components: {
    JInput,
  },
  data() {
    return {
      appid: '',
      loading: false,
      description: '自定义菜单页面',
      previewVisible: false,
      queryParam: {
        appid: '',
      },
      menuList: [],
      wechatApp: [],
      // 表头
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '菜单名称',
          dataIndex: 'menuName',
          key: 'menuName',
        },
        {
          title: '菜单层级',
          dataIndex: 'menuLevel',
          key: 'menuLevel',
        },
        {
          title: '菜单内容',
          dataIndex: 'menuContent',
          key: 'menuContent',
        },
        {
          title: '详细内容',
          dataIndex: 'contentDetails',
          key: 'contentDetails',
        },
      ],
      dictOptions: {},
    };
  },
  created() {
    this.getWechatApp();
  },
  computed: {},
  methods: {
    handleChange(value) {
      this.queryParam.appid = value;
      this.menuList = [];
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2',
      }).then((res) => {
        if (res.success) {
          console.log(res);
          this.queryParam.appid = res.result[0].appId;
          this.appid = res.result[0].appId;
          this.wechatApp = res.result;
          this.getMenu();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getMenu() {
      if (!this.queryParam.appid) {
        this.$message.warning('请选择渠道');
      } else {
        this.loading = true;
        getAction(
          process.env.VUE_APP_CMS_WECHAT + '/wechatMenu/getMenuChildren',
          { appId: this.queryParam.appid }
        ).then((res) => {
          if (res.success) {
            this.menuList = res.result;
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        });
      }
    },
    handleRouter() {
      if (!this.queryParam.appid) {
        this.$message.warning('请选择渠道');
      } else {
        this.$router.push({
          path: '/wechatManagement/customizeMenu/menu',
          query: { id: this.queryParam.appid },
        });
      }
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
